import { LinkDriveFolderDialog } from "@/components/folder/LinkDriveFolderDialog";
import { Button } from "@/components/ui/button";
import { useChatsData } from "@/data/use-chats-data";
import { useArtifactUuid } from "@/hooks/use-artifact-uuid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClockRotateLeft,
  faTrash,
} from "@nnr/fontawesome-sharp-light/icons/sharp/light";
import { useMatchRoute } from "@tanstack/react-router";
import { useState } from "react";
import { KitMenuTemplate } from "../KitMenuTemplate";
import { DeleteChatDialog } from "./DeleteChatDialog";
import { SETTINGS_GROUP_PARTIAL, useFolderGroup } from "./hooks";
import { KitTypeMenuProps } from "./types";

export const ConversationMenu: React.FC<KitTypeMenuProps> = ({
  mode,
  groupUuid,
  groupSlug,
  kit,
}) => {
  const chatUuid = useArtifactUuid("chatUuid");
  const matchRoute = useMatchRoute();
  const [deleteChatUuid, setDeleteChatUuid] = useState<string | null>(null);
  const [driveFolderDialog, setDriveFolderDialog] = useState(false);
  const { chats } = useChatsData(groupUuid, kit.uuid);
  const folderGroup = useFolderGroup({
    groupUuid,
    kitUuid: kit.uuid,
    onLinkDriveFolderClick: () => setDriveFolderDialog(true),
  });

  const groups: React.ComponentProps<typeof KitMenuTemplate>["groups"] = [
    {
      title: "Chat History",
      icon: faClockRotateLeft,
      showCounter: true,
      items: chats.map((u) => ({
        id: u.uuid,
        title: u.name,
        link: {
          to: "/w/$groupSlug/k/$kitUuid/chat/$chatUuid" as const,
          params: { groupSlug, kitUuid: kit.uuid, chatUuid: u.uuid },
        },
        active: u.uuid === chatUuid,
        dropdownMenu: [
          <Button
            variant="ghost"
            size="icon-sm"
            onClick={() => setDeleteChatUuid(u.uuid)}
          >
            <FontAwesomeIcon icon={faTrash} />
            Delete Chat
          </Button>,
        ],
      })),
    },
    folderGroup,
    {
      ...SETTINGS_GROUP_PARTIAL,
      active: !!matchRoute({
        to: "/w/$groupSlug/k/$kitUuid/chat-settings",
        params: { groupSlug, kitUuid: kit.uuid },
        fuzzy: true,
      }),
      link: {
        to: "/w/$groupSlug/k/$kitUuid/chat-settings" as const,
        params: { groupSlug, kitUuid: kit.uuid },
      },
    },
  ];
  return (
    <>
      <KitMenuTemplate kit={kit} groups={groups} mode={mode} />
      {deleteChatUuid && (
        <DeleteChatDialog
          chatUuid={deleteChatUuid}
          onOpenChange={() => setDeleteChatUuid(null)}
        />
      )}
      <LinkDriveFolderDialog
        open={driveFolderDialog}
        onOpenChange={setDriveFolderDialog}
        groupUuid={groupUuid}
        groupSlug={groupSlug}
        kitUuid={kit.uuid}
      />
    </>
  );
};
